export default {
  eyebrow: null,
  heading: null,
  heading_size: 'h4',
  copy:
    "<p>12 Bishop's Bridge Road\n" +
    'London W2 6AA, United Kingdom\n' +
    '+44 (0) 207 262 0011\n\n' +
    '<a href="#" target="_blank">Map</a>' +
    '</p>',
  cta: [],
  component: 'a-copy',
}
